import { SensorsRounded as SensorsRoundedIcon } from '@mui/icons-material'
import { Stack, Tooltip, Typography } from '@mui/material'
import { t } from 'i18next'

const StatusBadge = ({ isAlarm, isAlive, withMessage = true }) => {
  const choseStatus = (isAlarm) => isAlarm
    ? {
      color: 'error.main',
      msg: t('common.alarmed')
    }
    : {
      color: 'success.main',
      msg: t('common.online')
    }

  const status = isAlive
    ? choseStatus(isAlarm)
    : {
      color: 'gray.700',
      msg: t('common.offline')
    }

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      color={status.color}
    >
      <Tooltip title={status.msg}>
        <SensorsRoundedIcon />
      </Tooltip>
      {withMessage && (
        <Typography variant="p">
          <small>{status.msg}</small>
        </Typography>
      )}
    </Stack>
  )
}

export default StatusBadge
